import { type ZodType, z } from "zod";

export const requiredPositiveAmount = (
	requiredMessage: string,
	positiveMessage: string,
): ZodType<number, z.ZodTypeDef, number | null> =>
	z
		.number({
			required_error: requiredMessage,
			invalid_type_error: requiredMessage,
		})
		.nullable()
		.refine((value): value is number => value !== null, {
			message: requiredMessage,
		})
		.refine((value) => value > 0, { message: positiveMessage });
